import { printFunctionCall, printScript } from './printScript';
// ----- WARNING -----
// This is a very sensitive fraction of code.
// Any changes to this file must be tested directly in product before merging.
// The scripts printed here might differ from what we observe in our internal tests
// due to minimification, for example.

export var GLOBAL_MEDIA_CARD_SSR = 'mediaCardSsr';
export var GLOBAL_MEDIA_NAMESPACE = '__MEDIA_INTERNAL';
export function getMediaGlobalScope() {
  var globalScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  // Must match GLOBAL_MEDIA_NAMESPACE. Can't reference the constant from here.
  var namespace = '__MEDIA_INTERNAL';
  if (!globalScope[namespace]) {
    globalScope[namespace] = {};
  }
  return globalScope[namespace];
}
export function getMediaCardSSR() {
  var globalScope = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window;
  var globalMedia = getMediaGlobalScope(globalScope);
  // Must match GLOBAL_MEDIA_CARD_SSR. Can't reference the constant from here.
  var key = 'mediaCardSsr';
  if (!globalMedia[key]) {
    globalMedia[key] = {};
  }
  return globalMedia[key];
}
var dashed = function dashed(param) {
  return param ? "-".concat(param) : '';
};
export var getKey = function getKey(_ref) {
  var id = _ref.id,
    collectionName = _ref.collectionName,
    occurrenceKey = _ref.occurrenceKey;
  return "".concat(id).concat(dashed(collectionName)).concat(dashed(occurrenceKey));
};
export var storeDataURI = function storeDataURI(key, dataURI, dimensions, error) {
  var globalScope = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : window;
  var mediaCardSsr = getMediaCardSSR(globalScope);
  mediaCardSsr[key] = {
    dataURI: dataURI,
    dimensions: dimensions,
    error: error
  };
};
var generateScript = function generateScript(identifier, dataURI, dimensions, error) {
  var functionCall = printFunctionCall(storeDataURI, getKey(identifier), dataURI, dimensions, error);
  return printScript([getMediaCardSSR.toString(), getMediaGlobalScope.toString(), functionCall]);
};
export var generateScriptProps = function generateScriptProps(identifier, dataURI, dimensions, error) {
  return {
    dangerouslySetInnerHTML: {
      __html: generateScript(identifier, dataURI, dimensions, error)
    }
  };
};